// Copyright 2023 Amazon.com, Inc. or its affiliates. All Rights Reserved.
export enum CookieCategory {
  Essential = "Essential",
  Performance = "Performance",
  Functional = "Functional",
  Advertising = "Advertising",
}
